module.exports = __webpack_public_path__ + "img/mac.76e37300.jpg";